import { lazy } from 'react';
import type { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const WebsiteOrdersView = lazy(() => import('./WebsiteOrdersView'));
const routes: FuseRouteItemType[] = [
	{
		path: 'website-orders',
		auth: ['Admin', 'Manager', 'Employee'],
		element: <WebsiteOrdersView />
	}
];
export default routes;
